import React from 'react';
import { Button, Tag, Table, message, Input, Tabs } from 'antd';
import {redirectToHome, verifIsLogged, getPays, getFrDateFormat, getMachineId, setLanguage, getLanguage, setDisconnectMachineId} from "../../util/Toolbox";

import { withTranslation } from 'react-i18next';

import './../css/historique.css';

import MagasinFiche from "./MagasinFiche"
import SpintouchManagementAdaptive from "./SpintouchManagementAdaptive"
import SpintouchTest from "./SpintouchTest"
import ElectronDebug from "./ElectronDebug"

import NavBar from '../../components/NavBar';

import './../css/navBar.css';

import axios from '../../util/Api'

import {
  PlusOutlined,
  SettingOutlined,
  DatabaseOutlined,
  ExperimentOutlined,
  BugOutlined
} from '@ant-design/icons';

class Spintouch extends React.Component {

  state = {

    search : '',
    guid_compte: '',
    editionKey : '',
    inputValue : '',
    stateAjouterMagasin : false,
    magasin_LIST : [],
    isLoading : false,
    baseURL : '',
    magasinCurrent : null,
    language : getLanguage(),
    languages_LIST : [],
    activeTab : 'spintouch'

  }


  async componentDidMount() {

    verifIsLogged();

    let guid_compte = getMachineId();

    this.state.guid_compte = guid_compte;

    let languages_LIST = getPays();
    this.setState({languages_LIST : languages_LIST});

    const {i18n } = this.props;
    let newLang = getLanguage();
    i18n.changeLanguage(newLang);
    setLanguage(newLang);
    this.setState({language : newLang});


/*
    // On regarde accès admin pour cet utilisateur
    axios.get(`analyse/${this.state.guid_compte}/loadProfile`,
    ).then(({data}) => {
      console.log(data);

      if(data.success == 'success'){
        if(data.user.IsAccesBack == 0){
          message.error("Vous n'avez pas accès à cette page");
          redirectToHome();
        }
        this.loadMagasin();
      }

    }).catch(function (error) {
      console.log("Error****:", error.message);
      this.setState({isLoading : false})
    });
    */
  
    
  }

  handleSearch = (pe_search) => {

    this.state.search = pe_search;
    this.loadMagasin();
  };


        // Fonction pour changer la langue
  handleChangeLanguage = (event) => {
          const newLang = event.target.value;
          // Définir la langue  
          const {i18n } = this.props;
          console.log(newLang);
          i18n.changeLanguage(newLang);
          setLanguage(newLang);
          this.setState({language : newLang});
  };
  


  loadMagasin(){

    let search = '-1';

    if(this.state.search != ''){
      search = this.state.search;
    }

    this.setState({isLoading : true})
    axios.get(`analyse/${this.state.guid_compte}/${search}/magasin`,
    ).then(({data}) => {
      console.log(data);
      if(data.success == 'success'){
        this.setState({magasin_LIST : data.result, isLoading : false});
      }
    }).catch(function (error) {
      console.log("Error****:", error.message);
      this.setState({isLoading : false})
    });

  }


  addMagasin = () => {
   
    this.setState({stateAjouterMagasin : true})    
  }


  editMagasin(item){
    
    this.setState({stateAjouterMagasin : true, magasinCurrent : item})
  }


  closeMagasinAdresse = () => {
    this.setState({stateAjouterMagasin : false, magasinCurrent : null})
  }


  validateFicheMagasin = (magasin) => {
   
    axios.post('/analyse/updateMagasin', {magasin : magasin },
    ).then(({data}) => {
      console.log(data);
      this.loadMagasin();
      message.success("Mise à jour effectuée");
      //this.setState({editionKey : '', inputValue : '', magasin_LIST : magasin_LIST })
    }).catch(function (error) {
      console.log("Error****:", error.message);
      message.error("Erreur lors de l'analyse");
    });




    this.closeMagasinAdresse();
  }


  consulterAnalyse(item){

    window.location.href= '/analyse?analyse='+ item.GUID_Analyse;
  }

 

  partagerAnalyse(item){
  

    console.log(item);
    let url = `${this.state.baseURL}/analyse/${item.GUID_Analyse}/printAnalyse`;
    console.log(this.state.baseURL + url)

    let htmlEmail = `

      Cliquer sur le lien ci dessous pour visualiser l'analyse ${item.GUID_Analyse}
      ${url}

    `

    window.open(`mailto:?subject=Pool Solutions - Partage analyse&body=${encodeURIComponent(htmlEmail)}`);


  }

  editRow(item){

    this.setState({editionKey : item.GUID_Analyse , inputValue : item.ReferenceAnalyse});
  }

  copyRow(item){
   

    console.log('copyClipboard', item )
    navigator.clipboard.writeText(item)
    message.success("Sauvegardé dans le presse papier")

  }

  handleChange(inputValue) {
    this.setState({inputValue});
  }

  saveItem(item) {

    let GUID_Analyse       = this.state.editionKey;
    let magasin_LIST    = [...this.state.magasin_LIST] ;
    let ReferenceAnalyse   = this.state.inputValue ;

    console.log(ReferenceAnalyse);

    for (var i = 0; i < magasin_LIST.length; i++) {
      if(magasin_LIST[i].GUID_Analyse == GUID_Analyse){
        magasin_LIST[i].ReferenceAnalyse = ReferenceAnalyse;
      }
    }

    axios.post('/analyse/updateHistorique', {historique : {GUIDAnalyse : this.state.editionKey, LibelleAnalyse : this.state.inputValue } },
    ).then(({data}) => {
      this.setState({editionKey : '', inputValue : '', magasin_LIST : magasin_LIST })
      message.success("Mise à jour effectuée");
    }).catch(function (error) {
      console.log("Error****:", error.message);
      message.error("Erreur lors de l'analyse");
    });

  }

  render() {

    const { t, i18n } = this.props; // Récupérer la traduction et le changement de langue

      const columns = [

        {
          title: 'Magasin',
          dataIndex: 'NomMagasin',
          render: (text, record) => (
            <span style= {{textDecoration: 'underline' , cursor: 'pointer'}} onClick={() => this.editMagasin(record)}>
              {record.NomMagasin}
            </span>
          ),
          width: '30%',
          sorter: (a, b) => a.NomMagasin.localeCompare(b.NomMagasin),

        },

        {
          title: 'Adresse',
          dataIndex: 'Adresse',
          render: (text, record) => (
            <span>
              {record.AdresseMagasin + ' ' + record.CodePostalMagasin + ' ' + record.VilleMagasin}
            </span>
          ),
          sorter: (a, b) => a.AdresseMagasin.localeCompare(b.AdresseMagasin),
          width: '30%'
        },

        {
            title: 'Création',
            dataIndex: 'creation',
            render: (text, record) => (
              <span>
                {getFrDateFormat(record.DateCreationMagasin)}
              </span>
            ),
            width: '20%',
            sorter: (a, b) => a.DateCreationMagasin.localeCompare(b.DateCreationMagasin),
        },

        {
          title: 'Etat',
          dataIndex: 'Etat',
          render: (text, record) => (
            <span>
              {
                <Tag color={record.IsSommeil == 0 ? "success" : "warning"}>{record.IsSommeil == 0 ? "Actif" : "Désactivé" }</Tag>
                }
            </span>
          ),
          sorter: (a, b) => a.IsSommeil - b.IsSommeil,
          width: '20%'
      },

      {
          title: 'Identifiant',
          dataIndex: 'Login',
          render: (text, record) => (
            <span  style = {{cursor: 'pointer'}} onClick={() => this.copyRow(record.Login)}>
              {record.Login}
            </span>
          ),
          width: '20%'
      },

      {
        title: 'Mot de passe',
        dataIndex: 'Password',
        render: (text, record) => (
          <span  style = {{cursor: 'pointer'}} onClick={() => this.copyRow(record.Password)}>
            {record.Password}
          </span>
        ),
        width: '20%'
      },


       {
        title: 'Total analyse',
        dataIndex: 'NB_ANALYSE',
        render: (text, record) => (
          <span >
            {record.NB_ANALYSE}
          </span>
        ),
        width: '20%',
         sorter: (a, b) => a.NB_ANALYSE - b.NB_ANALYSE,
      },


      
       
      ];

      const tabItems = [
      
        {
          key: 'spintouch',
          active: true,
          label: (
            <span>
              <SettingOutlined />
              Gestion Spintouch
            </span>
          ),
          children: <SpintouchManagementAdaptive t={t} />
        },
       
       
      ];

      return (

        <div>

          <div className = "wrapper_historique">

            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>

            <NavBar
              t={t}
              isElectron={false}
              updateStatus=""
              IsAdmin={true}
              onLanguageChange={this.handleChangeLanguage}
            />

            <div className = "containersHistorique">

              <Tabs
                activeKey={this.state.activeTab}
                onChange={(key) => this.setState({ activeTab: key })}
                items={tabItems}
                size="large"
              />

            </div>

          </div>

        </div>

      )

    };
}



export default withTranslation() (Spintouch);
